import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Box, Typography } from "@mui/material";

const TrustStats = () => {
    return (
        <Box
            sx={{
                mt: { xs: 2, md: 3 },
                mx: "auto",
                maxWidth: "760px",
                minHeight: { xs: 72, md: 82 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(90deg, #07358f 0%, #0b4db5 50%, #07358f 100%)",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: "5px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
                position: "relative",
                overflow: "hidden",
                px: { xs: 1.5, md: 3 },
                py: { xs: 1.5, md: 1 },
            }}
        >
            {/* Left sctn - Registrations */}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: { xs: 1, md: 1.5 },
                }}
            >
                <WorkspacePremiumIcon
                    sx={{
                        color: "#FFC107",
                        fontSize: { xs: 34, md: 46 },
                    }}
                />

                <Box sx={{ textAlign: "left" }}>
                    <Typography
                        sx={{
                            color: "#FFC107",
                            fontWeight: 800,
                            fontSize: { xs: 17, md: 22 },
                            lineHeight: 1.1,
                            fontFamily: "Poppins",
                        }}
                    >
                        2000+
                    </Typography>

                    <Typography
                        sx={{
                            color: "#fff",
                            fontWeight: 500,
                            fontSize: { xs: 12, md: 15 },
                            lineHeight: 1.2,
                            fontFamily: "Poppins",
                        }}
                    >
                        Registrations
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    width: "1px",
                    height: { xs: 42, md: 52 },
                    backgroundColor: "rgba(255,255,255,0.35)",
                    mx: { xs: 1, md: 3 },
                }}
            />

            {/* Right sctn- Trusted */}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: { xs: 1, md: 1.5 },
                }}
            >
                <VerifiedUserIcon
                    sx={{
                        color: "#FFC107",
                        fontSize: { xs: 34, md: 46 },
                    }}
                />

                <Box sx={{ textAlign: "left" }}>
                    <Typography
                        sx={{
                            color: "#fff",
                            fontWeight: 500,
                            fontSize: { xs: 10, md: 12 },
                            lineHeight: 1.2,
                            fontFamily: "Poppins",
                        }}
                    >
                        Trusted by
                    </Typography>

                    <Typography
                        sx={{
                            color: "#FFC107",
                            fontWeight: 700,
                            fontSize: { xs: 12, md: 15 },
                            lineHeight: 1.3,
                            fontFamily: "Poppins",
                        }}
                    >
                        Students & Parents
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default TrustStats;
